export const shareQueryParams = {
  FILTER_ID: "filterId",
  SCOPE_ID: "scopeId",
  FILTER_TO_EXECUTE: "filterToExecute",
  SCOPE_TO_EXECUTE: "scopeToExecute",
  DATASOURCE: "datasource",
  TIME_SCALE: "timeScale",
  RULE_NAME: "ruleName",
} as const;
